<template>
  <section>
    <div class="section-header" @click="$emit('toggle-open')" :class="{opened: open}">
      <h2>{{ title }}</h2>
      <ChevronUpIcon class="icon" v-if="open"/>
      <ChevronDownIcon class="icon" v-else/>
    </div>
    <div class="section-content" v-if="open">
      <div class="content">
        <slot></slot>
      </div>
      <div class="button-container">
        <Button v-if="showCancelButton" class="cancel-button" @click="$emit('cancel')">Afbreken</Button>
        <Button v-if="showExtraButton" class="extra-button" @click="$emit('extra')">Extra</Button>
        <Button class="next-button" v-if="showNextButton" @click="$emit('open-next')" :disabled="isLoading">
          <ArrowRightIcon v-if="!isLoading" />
          <LoadingIndicator v-else
                            style="height: 16px;"/>
          Volgende
        </Button>
      </div>
    </div>
  </section>
</template>

<script>

import Button from "@/components/Button";
import LoadingIndicator from "@/components/LoadingIndicator";
import {ArrowRightIcon, ChevronDownIcon, ChevronUpIcon} from "vue-feather-icons";
import {mapState} from "vuex";

export default {
	components: {
		ChevronDownIcon,
		ChevronUpIcon,
		Button,
		ArrowRightIcon,
		LoadingIndicator
	},
	props: {
	title: String,
	open: Boolean,
	showNextButton: Boolean,
	showCancelButton: false,
	showExtraButton: false
	},

	data() {
		return {};
	},
	computed: {
		...mapState({
			isLoading: "loading"
		})
	},
	methods: {}
};
</script>
<style lang="scss" scoped>
section {
	background: #f7f9fa;
}

.section-header {
	margin: 0 0 0 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	h2 {
		font-weight: 400;
	}

	&.opened {
		h2 {
			text-transform: uppercase;
			font-weight: 600;
		}
	}

	.icon {
		height: 48px;
		width: 48px;
	}
}

.section-content {
	margin: 0 8px;

  .button-container {
    display: flex;

    .cancel-button {
      margin: 8px 0 8px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 5px 16px;
      background-color: #E53935;
      color: white;
      border: none;
      border-radius: 4px;
      font-weight: bold;
      height: 36px;
      min-width: 130px;
    }

    .extra-button {
      margin: 8px 0 8px 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 5px 16px;
      background-color: #e8833a;
      color: white;
      border: none;
      border-radius: 4px;
      font-weight: bold;
      height: 36px;
      min-width: 130px;
    }

    .next-button {
      align-self: flex-end;
      margin: 8px 0 8px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 5px 16px;
      background-color: #35a5a4;
      color: white;
      border: none;
      border-radius: 4px;
      font-weight: bold;
      height: 36px;
      min-width: 130px;


      svg {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }
  }
}
</style>
